import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PrivatePageLayout, PageHeader, PageTableCard } from '../../components/PrivatePage';
import { getLogList } from '../../services/LogsService';
import Pagination from '../../components/Pagination/Pagination';
import Toast from '../../components/Toast/Toast';
import LogModal from '../../components/Logs/LogModal';
import LogRow from './LogRow';
import BeholderButton from './Beholder/BeholderButton';
import BeholderModal from './Beholder/BeholderModal';
import SelectUser from './SelectUser';

function Logs() {
    const defaultLocation = useLocation();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    const history = useHistory();

    useEffect(() => {
        return history.listen((location) => {
            setPage(getPage(location));
        });
    }, [history]);

    const [logs, setLogs] = useState([]);
    const [count, setCount] = useState(0);
    const [notification, setNotification] = useState({ type: '', text: '' });
    const [viewLog, setViewLog] = useState('');
    const [userId, setUserId] = useState('');
    const [page, setPage] = useState(getPage());

    useEffect(() => {
        getLogList(userId, page || 1)
            .then((result) => {
                setLogs(result.rows);
                setCount(result.count);
            })
            .catch((err) => {
                console.error(err.response ? err.response.data : err.message);
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
            });
    }, [page, userId]);

    function onViewClick(event) {
        const file = event.target.id.replace('logs', '');
        setViewLog(file.replace('.log', ''));
    }

    function onUserChange(event) {
        setUserId(event.target.value);
    }

    return (
        <PrivatePageLayout>
            <PageHeader
                eyebrow="Admin"
                title="Logs"
                subtitle="Inspect system and user logs, plus Beholder memory."
                actions={(
                    <div className="private-page-header-filters">
                        <BeholderButton />
                        <SelectUser onChange={onUserChange} />
                    </div>
                )}
            />
            <PageTableCard>
                <div className="table-wrapper table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Log file</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs && logs.length
                                ? logs.map((log) => (
                                    <LogRow key={log} data={log} onViewClick={onViewClick} />
                                ))
                                : null}
                        </tbody>
                    </table>
                </div>
                <Pagination count={count} />
            </PageTableCard>
            <BeholderModal />
            <LogModal file={viewLog} />
            <Toast type={notification.type} text={notification.text} />
        </PrivatePageLayout>
    );
}

export default Logs;